module.exports = __webpack_public_path__ + "img/zm.2b5f9a1c.svg";